module.exports = __webpack_public_path__ + "img/hotel-icon-map.d8c59013.svg";